import { formatColumnDate, formatLongPrice, formatPercentage, getPureNumber, getValueBgClass } from '../../lib/utils';
import styled from '@benzinga/themetron';

export const Economics = [
  {
    cellClass: 'ticker-cell',
    field: 'date',
    headerName: 'Date',
    valueFormatter: ({ data }: any) => formatColumnDate(data.date),
    valueGetter: ({ data }: any) => {
      if (!data.date) return null;
      return data.date;
    },
    width: 70,
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: ({ data }: any) => {
      return (
        <>
          <StyledCountryFlagIcon className="country-flag-icon" code={data.country} />
          {data.country}
        </>
      );
    },
    field: 'country',
    valueFormatter: ({ data }: any) => data.country,
    width: 60,
  },
  {
    cellClass: 'ticker-cell',
    field: 'event_name',
    headerName: 'Econ Event',
    width: 160,
  },
  {
    cellClass: 'ticker-cell',
    cellStyle: { fontWeight: '900' },
    field: 'actual',
    valueFormatter: ({ value }: any) => formatLongPrice(value, ''),
    valueGetter: ({ data }: any) => getPureNumber(data.actual),
    width: 40,
  },
  {
    cellClass: ({ value }: any) => getValueBgClass(value),
    cellStyle: { fontWeight: 'bold', textAlign: 'left' },
    field: 'surprise',
    headerName: 'Surprise',
    valueFormatter: ({ value }: any) => formatPercentage(value),
    valueGetter: ({ data }: any) => {
      if (data.consensus === '' || data.consensus === undefined || data.actual === '' || data.actual === undefined)
        return null;
      return (data.consensus - data.actual) / data.consensus;
    },
    width: 60,
  },
];

const StyledCountryFlagIcon = styled.div<{ code: string }>`
  &.country-flag-icon {
    margin-right: 0.3125rem;
    background-color: #fff;
    background: ${({ code }) =>
        `url(https://www.benzinga.com/wp-content/themes/benzinga-money/dist/rebuild/images/icons/countries-flags/alpha3/${code}.svg)`}
      no-repeat;
    background-size: cover;
    border: 1px solid #d6d6d6;
    display: inline-block;
    vertical-align: middle;
    width: 17px;
    height: 12px;
  }
`;
